import examReducer from './examReducer'
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authReducer'

import storage from 'redux-persist/lib/storage' // dùng localStorage
import { persistReducer, persistStore } from 'redux-persist'
import { combineReducers } from 'redux'

// Cấu hình persist
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'] // chỉ lưu auth reducer
}

// Gộp reducer
const rootReducer = combineReducers({
    auth: authReducer,
    exam: examReducer
})

// Bọc rootReducer bằng persist
const persistedReducer = persistReducer(persistConfig, rootReducer)

// Tạo store
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // tránh warning với redux-persist
        }),
})

// Tạo persistor
export const persistor = persistStore(store)
